import { Modal } from 'ant-design-vue';
export default {
  axiosError(error) {
    var errors = error.response.data.errors;
    if (errors) {
      var error_list = Object.keys(errors).map((f) => {
        return errors[f][0];
      });
      console.log(error_list);
      this.alert(error_list[0]);
    } else {
      console.log('error.response.data.message', error.response.data.message);
      this.alert(error.response.data.message);
    }
  },
  alert(text) {
    return new Promise((resolve, reject) => {
      Modal.error({
        title: 'Nofify',
        content: text,
        onOk() {
          resolve(true);
        },
      });
    });
  },
  alertSuccess(text) {
    return new Promise((resolve, reject) => {
      Modal.success({
        title: 'Nofify',
        content: text,
        onOk() {
          resolve(true);
        },
      });
    });
  },
  alertError(error) {
    var error_list = Object.keys(error).map((f) => {
      return error[f][0];
    });
    return new Promise((resolve, reject) => {
      Modal.error({
        title: 'Nofify',
        content: error_list[0],
        onOk() {
          resolve(true);
        },
      });
    });
  },
  confirm(text) {
    return new Promise((resolve, reject) => {
      Modal.confirm({
        title: 'Nofify',
        content: text,
        onOk() {
          resolve(true);
        },
      });
    });
  },
};
